const pharmacyRoutes = [
  {
    name: "Dashboard",
    route: "/pharmacy",
    icon: `<svg class="w-6 h-6" ...>Home icon</svg>`,
  },
  {
    name: "OTC Sales",
    route: "/pharmacy/otc-sales",
    icon: `<svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h10M9 9h6" />
    </svg>`,
  },
  {
    name: "External Prescriptions",
    route: "/pharmacy/external-prescriptions",
    icon: `<svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6M9 16h6M9 8h2M5 4h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"/>
    </svg>`,
  },
];

export default pharmacyRoutes;
